import React from "react";
import { serverApi, serverUrl } from "../../../confing/confing";
import toast from "react-hot-toast";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Pagination from "../../Pagination/Pagination";
import { getAllCategory } from "../../../services/kojaServices";
import { FaSearch } from "react-icons/fa";

const ExpertSheets = () => {
  const [list, setList] = useState([]);
  const { id } = useParams();
  const [page, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [status, setStatus] = useState("all");
  const [category, setCategory] = useState([]);
  const [category2, setCategory2] = useState(0);
  const [value, setValue] = useState("");
  const [type, setType] = useState("address");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          let token = localStorage.getItem("token");
          const { data } = await axios.get(
            `${serverApi}admin/expert-requests/${id}?limit=${10}&page=${page}`,
            {
              headers: { authorization: `Bearer ${token}` },
            }
          );
          console.log(data);
          setList(data.result);
          setList(data.result);
          setTotalPage(data.totalPage);
        }
        // setInfo(data.result);
      } catch (err) {
        console.log(err);
        toast.error("خطایی رخ داده است مجددا تلاش کنید");
      }
    };
    fetchData();
  }, [page]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: category } = await getAllCategory();
        setCategory(category.result);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  const search = async () => {
    try {
      let token = localStorage.getItem("token");
      const { data } = await axios.get(
        `${serverApi}/admin/expert-requests/${id}?limit=10&type=${type}&value=${value}&category=${category2}&status=${status}`,
        { headers: { authorization: `Bearer ${token}` } }
      );
      console.log(data);
      setList(data.result);
    } catch (err) {
      console.log(err);
      toast.error("خطایی رخ داده است مجددا تلاش کنید");
    }
  };
  return (
    <div className="p-3 px-lg-5 py-lg-3">
      <div className="row g-0 align-items-center my-requstes-filter-box p-2 my-2">
        <div className="mb-2 mb-md-0 p-1 col-6 col-md-2">
          <select
            className="my-requstes-filter-item w-100"
            onChange={(e) => {
              setCategory2(e.target.value);
            }}
          >
            <option value={0}>نوع ملک</option>
            {category.map((s, index) => (
              <option key={index} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-2 mb-md-0 p-1 col-6 col-md-2">
          <select
            className="my-requstes-filter-item w-100"
            onChange={(e) => {
              setStatus(e.target.value);
            }}
          >
            <option>وضعیت</option>
            <option value="all">همه</option>
            <option value="Pending">در انتظار ثبت صورت</option>
            <option value="WaitingForPay">در انتظار پرداخت</option>
            <option value="Finish">کارشناسی شده</option>
            <option value="Approved">در انتظار تایید</option>
          </select>
        </div>
        <div className="mb-2 mb-md-0 p-1 col-4 col-md-2">
          <select
            className="my-requstes-filter-item w-100"
            onChange={(e) => {
              setType(e.target.value);
            }}
          >
            <option>جستجو بر اساس</option>
            <option value="address">آدرس</option>
            <option value="reqToken">شماره صورت کارشناسی</option>
            <option value="tell">شماره تماس</option>
            <option value="name">نام مالک</option>
          </select>
        </div>
        <div className="mb-2 mb-md-0 p-1 col-7 col-md-5">
          <input
            placeholder="جستجو"
            className="my-requstes-filter-item w-100"
            onBlur={(e) => {
              setValue(e.target.value);
            }}
          />
        </div>
        <div className="col-1 p-1">
          <button
            className="btn p-1 px-md-2"
            style={{ backgroundColor: "#EF971C", color: "#FFF" }}
            onClick={() => {
              search();
            }}
          >
            <FaSearch />
          </button>
        </div>
      </div>
      <div
        className="table-responsive p-0"
        style={{
          border: "1px solid #fff",
          borderRadius: "20px",
          backgroundColor: "rgba(255, 255, 255, 0.50)",
        }}
      >
        <table
          className="table table-bordered text-center mb-0"
          style={{ borderRadius: "20px" }}
        >
          <thead>
            <tr style={{ color: "#000" }}>
              <th scope="col">ردیف</th>
              <th scope="col">شماره صورت</th>
              <th scope="col">شماره تماس</th>
              <th scope="col">مالک</th>
              <th scope="col">نوع ملک</th>
              <th scope="col">آدرس</th>
              <th scope="col">تاریخ و ساعت</th>
            </tr>
          </thead>
          <tbody>
            {list.map((i, index) => (
              <tr style={{ color: "#000" }} key={index}>
                <td>{index + 1}</td>
                <td>{i.requestToken}</td>
                <td>{i.Ex_Owner.tel}</td>
                <td>{i.Ex_Owner.name}</td>
                <td>{i.Ex_Category.name}</td>
                <td>{i.address.substring(0, 30)}</td>
                <td>{i.expert[0]?.Ex_Expertors.faDateTime}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-3">
        <Pagination
          setPageNumber={setPageNumber}
          page={page}
          totalPage={totalPage}
        />
      </div>
    </div>
  );
};

export default ExpertSheets;
